export default __webpack_public_path__ + "static/media/work-3a.635b04b9.png";